/**
 * 施設のIDを取得
 * @param my
 */
const getServiceId = (my: any) => {
  return my.current_service_id ? my.current_service_id : my.service_id;
};

export default getServiceId;
